import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

export function utcToZone(utcIso: string, zone: string = dayjs.tz.guess()) {
  return dayjs.utc(utcIso).tz(zone);
}

export function formatUtcToZone(utcIso: string, format: string = 'DD.MM.YYYY HH:mm', zone?: string): string {
  const resolvedZone = zone ?? dayjs.tz.guess();
  return utcToZone(utcIso, resolvedZone).format(format);
}
